const menu_ready = (callback) => {
   if (document.readyState != "loading") callback();
   else document.addEventListener("DOMContentLoaded", callback);
};

menu_ready(() => {
   const menuOpenButton = document.querySelector('.js-open-menu');
   const menuCloseButton = document.querySelector('.js-close-menu');
   const megaMenu = document.querySelector('.wcl-mega-menu');
   const menuItems = megaMenu.querySelectorAll('.menu-item-has-children');
   const body = document.querySelector('body');

   // Opening the menu when clicking on .js-menu-open
   if (menuOpenButton && megaMenu) {
      menuOpenButton.addEventListener('click', function () {
         megaMenu.classList.add('opened');
         body.classList.add('overflow-hidden');

         setTimeout(() => {
            const menuItems = megaMenu.querySelectorAll('.menu > li');

            menuItems.forEach((item, index) => {
               setTimeout(() => {
                  item.classList.add('wcl-menu-item-anim');
               }, index * 150);
            });
         }, 500);
      });
   }

   // Close menu when clicking .js-close-menu
   if (menuCloseButton && megaMenu) {
      menuCloseButton.addEventListener('click', function () {
         // Remove animation class from menu items
         const menuItems = document.querySelectorAll('#menu-header-menu > li');

         menuItems.forEach((item, index) => {
            setTimeout(() => {
               item.classList.remove('wcl-menu-item-anim');
            }, index * 150);
         });

         setTimeout(() => {
            megaMenu.classList.remove('opened');
            body.classList.remove('overflow-hidden');
         }, 500);
      });
   }

   menuItems.forEach(item => {
      item.addEventListener('click', function (event) {
         // Find all .sub-menus on the page
         const allSubMenus = document.querySelectorAll('.sub-menu');

         // Remove the 'active' class from all submenus
         allSubMenus.forEach(subMenu => {
            subMenu.classList.remove('active');
         });

         // Find .sub-menu inside the current element
         const subMenu = item.querySelector('.sub-menu');

         if (subMenu) {
            // Add or remove class 'active' to .sub-menu
            subMenu.classList.toggle('active');
         }
      });
   });


   /*
* Adding height to the menu if we are on extension 992-577
*/
   window.addEventListener('DOMContentLoaded', function () {
      setMinHeight();
   });

   window.addEventListener('resize', function () {
      setMinHeight();
   });

   function setMinHeight() {
      const menuWrapper = document.querySelector('.data-menu-wrapper');
      const subMenu = document.querySelector('.menu-has-icons .sub-menu');

      if (window.innerWidth >= 577 && window.innerWidth <= 992 && subMenu) {
         // Get the height of the submenu
         const subMenuHeight = subMenu.clientHeight;

         // Set height as min-height for .data-menu-wrapper
         menuWrapper.style.minHeight = subMenuHeight + 'px';
      } else {
         // Reset min-height if screen width is greater than or equal to 992px
         menuWrapper.style.minHeight = 'auto';
      }
   }
});
